module.exports = __webpack_public_path__ + "img/hyu_gallery7.8c27282c.jpg";